import * as React from 'react'

function SvgIconBatteryMid(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="battery-mid" aria-labelledby="t-battery-mid d-battery-mid">
        <title id="t-battery-mid">{'Half battery'}</title>
        <desc id="d-battery-mid">{'A half-charged electric battery'}</desc>
        <path d="M10 17h12v11H10V17z" />
        <path d="M19 1v3h5v26H8V4h5V1h6m0-1h-6c-.6 0-1 .4-1 1v2H8c-.6 0-1 .4-1 1v27c0 .6.4 1 1 1h16c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1h-4V1c0-.6-.4-1-1-1z" />
      </g>
    </svg>
  )
}

export default SvgIconBatteryMid
